import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/financial-year-list`;

export const financialYearListRoutesObj = {
  list: baseRoute,
} as const;

export type IFinancialYearListRouteParams = IExtractRouteParamMap<
  typeof financialYearListRoutesObj
>;

export const financialYearListPath = createPaths<
  typeof financialYearListRoutesObj,
  IFinancialYearListRouteParams
>(financialYearListRoutesObj);
